<template>
  <div class="number-stepper" :qid="qid">
    <button type="button"
            class="number-stepper__button"
            :disabled="disabled || currentValue <= min"
            :aria-label="$t('system.decrease')"
            @click="setValue(currentValue - 1)"
            :qid="qid + '-decrease'"
    >
      <font-awesome-icon icon="minus"/>
    </button>
    <input type="text"
           class="number-stepper__input"
           inputmode="numeric"
           :value="currentValue"
           :disabled="disabled"
           @input="onInput"
           @blur="onBlur"
           @keydown.up.prevent="setValue(currentValue + 1)"
           @keydown.down.prevent="setValue(currentValue - 1)"
           :qid="qid + '-input'"
    />
    <button type="button"
            class="number-stepper__button"
            :disabled="disabled || currentValue >= max"
            :aria-label="$t('system.increase')"
            @click="setValue(currentValue + 1)"
            :qid="qid + '-increase'"
    >
      <font-awesome-icon icon="plus"/>
    </button>
  </div>
</template>

<script>
  // Whole numbers only, between min and max
  export default {
    name: 'NumberStepper',
    props: {
      value: {
        type: [Number, String],
        default: 0
      },
      min: {
        type: Number,
        default: 0
      },
      max: {
        type: Number,
        default: 99
      },
      disabled: {
        type: Boolean,
        default: false
      },
      qid: {
        type: String,
        default: 'number-stepper'
      }
    },
    computed: {
      currentValue() {
        return this.clamp(this.value);
      }
    },
    methods: {
      clamp(value) {
        let number = parseInt(value, 10);
        if (isNaN(number)) {
          number = this.min;
        }
        return Math.min(this.max, Math.max(this.min, number));
      },
      setValue(value) {
        this.$emit('input', this.clamp(value));
      },
      onInput(event) {
        let raw = event.target.value.trim();
        if (raw === '') {
          return;
        }
        // Whole numbers only: a minus sign gives the minimum, decimals are cut off
        let digits = raw.charAt(0) === '-' ? '' : (raw.match(/^\d+/) || [''])[0];
        let value = digits === '' ? this.min : this.clamp(digits);
        event.target.value = value;
        this.$emit('input', value);
      },
      onBlur(event) {
        let value = this.clamp(event.target.value);
        event.target.value = value;
        this.$emit('input', value);
      }
    }
  };
</script>
